module.exports = __webpack_public_path__ + "img/img_shiyanshi.41228cb3.jpg";